import { render, staticRenderFns } from "./FGDictRendererCN.vue?vue&type=template&id=3a0f8341"
import script from "./FGDictRendererCN.vue?vue&type=script&lang=js"
export * from "./FGDictRendererCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports